import { Link } from '@tanstack/react-router'
import { Map } from 'lucide-react'

import { cn } from '@/lib/utils'

import { ChipSessao } from '@/components/gestor/ChipSessao'
import { buttonVariants } from '@/components/ui/button'

/*
 * O que o cabeçalho tem à direita dentro da Área do Gestor: o caminho de volta
 * ao observatório e, com sessão, o chip da pessoa. Substitui a busca do mapa,
 * que não faz sentido aqui. Abaixo de 576px o botão encolhe ao ícone, para a
 * marca e o chip caberem na janela.
 */
export function AcoesDoGestor() {
  return (
    <div className="flex flex-none items-center gap-2">
      <Link
        to="/"
        className={cn(buttonVariants({ variant: 'primary', size: 'icon' }), 'sm:w-auto sm:px-4')}
      >
        <Map aria-hidden="true" className="sm:hidden" />
        <span className="sr-only sm:not-sr-only">Observatório</span>
      </Link>
      <ChipSessao />
    </div>
  )
}
